/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/components/SignupError.js":
/*!***********************************************!*\
  !*** ./src/scripts/components/SignupError.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"setupSignin\": () => (/* binding */ setupSignin)\n/* harmony export */ });\n/* harmony import */ var _utils_QuerySelector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/QuerySelector.js */ \"./src/scripts/utils/QuerySelector.js\");\n\nconst dom = {};\nconst qs = {\n  error: 'data-signup-error'\n};\nconst setupSignin = () => {\n  (0,_utils_QuerySelector_js__WEBPACK_IMPORTED_MODULE_0__.cacheDom)(dom, qs);\n  const params = (0,_utils_QuerySelector_js__WEBPACK_IMPORTED_MODULE_0__.URLQueryParams)();\n\n  if (params.refer && params.refer === 'signup' || params.return_url && params.return_url.includes('refer')) {\n    dom.error.classList.remove('hidden');\n  }\n};\n\n//# sourceURL=webpack://gaia-theme/./src/scripts/components/SignupError.js?");

/***/ }),

/***/ "./src/scripts/templates/login.js":
/*!****************************************!*\
  !*** ./src/scripts/templates/login.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _components_SignupError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/SignupError.js */ \"./src/scripts/components/SignupError.js\");\n\nconst dom = {};\nconst selectors = {\n  signInContainer: '.sign-in',\n  forgotContainer: '.forgot-password',\n  goToForgotBtn: '[data-go-forgot]',\n  goToSignInBtn: '[data-go-signin]'\n};\n\nconst cacheDom = () => {\n  dom.signInContainer = document.querySelector(selectors.signInContainer);\n  dom.forgotContainer = document.querySelector(selectors.forgotContainer);\n  dom.goToForgotBtn = document.querySelector(selectors.goToForgotBtn);\n  dom.goToSignInBtn = document.querySelector(selectors.goToSignInBtn);\n};\n\nconst resetForgotForm = () => {\n  [...dom.forgotContainer.querySelectorAll('.alert')].forEach(alert => alert.remove());\n  dom.forgotContainer.querySelector('#ForgotForm-email').value = '';\n};\n\nconst bindEvents = () => {\n  dom.goToForgotBtn && dom.goToForgotBtn.addEventListener('click', e => {\n    resetForgotForm();\n    dom.signInContainer.classList.add('hidden');\n    dom.forgotContainer.classList.remove('hidden');\n  });\n  dom.goToSignInBtn && dom.goToSignInBtn.addEventListener('click', e => {\n    dom.forgotContainer.classList.add('hidden');\n    dom.signInContainer.classList.remove('hidden');\n  });\n};\n\nconst init = () => {\n  // Allow deep linking to recover password form\n  if (window.location.hash === '#recover') {\n    dom.signInContainer && dom.signInContainer.classList.add('hidden');\n    dom.forgotContainer && dom.forgotContainer.classList.remove('hidden');\n  } else {\n    dom.forgotContainer && dom.forgotContainer.classList.add('hidden');\n    dom.signInContainer && dom.signInContainer.classList.remove('hidden');\n  }\n};\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  cacheDom();\n  bindEvents();\n  init();\n  (0,_components_SignupError_js__WEBPACK_IMPORTED_MODULE_0__.setupSignin)();\n});\n\n//# sourceURL=webpack://gaia-theme/./src/scripts/templates/login.js?");

/***/ }),

/***/ "./src/scripts/utils/QuerySelector.js":
/*!********************************************!*\
  !*** ./src/scripts/utils/QuerySelector.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"cacheDom\": () => (/* binding */ cacheDom),\n/* harmony export */   \"URLQueryParams\": () => (/* binding */ URLQueryParams)\n/* harmony export */ });\nconst cacheDom = (dom, selectors = {}, selectorsAll = {}, assumeAttributes = true) => {\n  Object.keys(selectors).forEach(selectorName => {\n    const selector = selectors[selectorName];\n    const qs = assumeAttributes ? `[${selector}]` : selector;\n    dom[selectorName] = document.querySelector(qs) || false;\n  });\n  Object.keys(selectorsAll).forEach(selectorName => {\n    const selector = selectorsAll[selectorName];\n    const qs = assumeAttributes ? `[${selector}]` : selector;\n    dom[selectorName] = [...document.querySelectorAll(qs)];\n  });\n  return dom;\n};\nconst URLQueryParams = () => {\n  return Object.fromEntries(new URLSearchParams(window.location.search));\n};\n\n//# sourceURL=webpack://gaia-theme/./src/scripts/utils/QuerySelector.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/templates/login.js");
/******/ 	
/******/ })()
;